import styled from 'styled-components';

export const ActionPlanTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_md};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	margin-bottom: 16px;
`;

export const ActionPlanContainer = styled.div`
	width: 100%;
	background-color: ${({ theme }) => theme.palette.secondary[100]};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	overflow: hidden;
`;

export const TaskHeader = styled.div`
	background-color: ${({ theme }) => theme.palette.secondary[100]};
	padding: 12px 16px;
	text-align: center;
	border-bottom: 1px solid white;
`;

export const TaskDetails = styled.div`
	padding: 16px;
	background-color: ${({ theme }) => theme.palette.secondary[50]};
`;

export const DetailRow = styled.div`
	margin-bottom: 8px;

	&:last-child {
		margin-bottom: 0;
	}
`;

export const DetailLabel = styled.span`
	font-weight: 600;
	color: #333;
	margin-right: 8px;
	min-width: 100px;
`;

export const DetailValue = styled.span`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	flex: 1;
	word-wrap: break-word;
`;

export const TasksHeader = styled.div`
	background-color: ${({ theme }) => theme.palette.secondary[100]};
	padding: 12px 16px;
	text-align: center;
	border-top: 1px solid white;
	border-bottom: 1px solid white;
`;

export const TasksTable = styled.table`
	width: 100%;
	border-collapse: collapse;
	background-color: white;
	text-align: center;

	thead {
		background-color: ${({ theme }) => theme.palette.secondary[50]};

		th {
			padding: 12px 16px;
			text-align: center;
			font-weight: 600;
			font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
			color: ${({ theme }) => theme.palette.secondary[400]};
			border-bottom: 2px solid white;
		}
	}

	tbody {
		tr {
			td {
				padding: 12px 16px;
				font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
				color: ${({ theme }) => theme.palette.secondary[400]};
				background-color: ${({ theme }) => theme.palette.secondary[50]};
				border-bottom: 2px solid white;
				text-align: center;
			}
		}
	}
`;
